import {
    EVIDENCE_LIST_RESPONSE,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"

const defaultState = {}

export default (state = defaultState, action) => {
    const { type, data } = action
    switch (type) {
        case EVIDENCE_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case UNAUTHENTICATED:
            return defaultState
        default:
            return state
    }
}
